import { PauseIcon, PlayIcon } from '@/components/Icons';
import Show from '@/components/Show';
import { Button } from '@/components/ui/button';
import { SkeletonWrapper } from '@/components/ui/SkeletonWrapper';
import { getUploadSignUrl } from '@/service';
import useGeneratorStore, { GeneratorTypeEnums, R3ImageTypeEnum, RecordingStatusEnum } from '@/state/generator-store';
import { useRequest } from 'ahooks';
import React, { useEffect, useRef } from 'react';
import { usePreviewPlayerCard } from '../../../components/PreviewPlayerCard/usePreviewPlayerCard';
import { useModel } from '../model';

interface RecordingConfirmProps {
  showButtons?: boolean;
  hide?: () => void;
}
export default function RecordingConfirm({ showButtons = true, hide }: RecordingConfirmProps): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null);

  const {
    audioPlayerLoading,
    setRecordingStatus,
    currentRecordFile,
    setCurrentRecordFile,
    setGeneratorType,
    hummingAudioSelected,
    r3ImageType,
  } = useGeneratorStore();

  const { uploadRecordingFile } = useModel();

  const { run: getUploadSignUrlRun } = useRequest(getUploadSignUrl, {
    manual: true,
    onSuccess: (res) => {
      setCurrentRecordFile({
        ...currentRecordFile,
        src: res?.data?.sign_url,
      });
    },
  });

  useEffect(() => {
    if (r3ImageType === R3ImageTypeEnum.select && hummingAudioSelected?.id) {
      getUploadSignUrlRun({
        id: String(hummingAudioSelected?.id),
      });
    }
  }, []);

  const { isPlaying, currentTime, onPlayPause } = usePreviewPlayerCard({
    signUrl: currentRecordFile?.src,
    containerRef,
  });

  const handleRecordAgain = () => {
    setRecordingStatus(RecordingStatusEnum.WaitingRecording);
  };

  return (
    <div className="w-full h-[320px] max-w-md p-4 bg-[#161718] rounded-lg">
      <div className="text-jen-orange text-[10px] font-pressura-mono font-normal uppercase">
        UPLOADED <br /> TRACK:
      </div>
      <div className="flex flex-col py-2 mt-6 bg-[#1d1e1f] rounded-t-lg">
        <SkeletonWrapper loading={audioPlayerLoading} className="p-4 w-full">
          <div className="cursor-pointer w-full" ref={containerRef} />
        </SkeletonWrapper>
        <div className="p-4">
          <div className="flex items-center gap-2">
            <button
              onClick={onPlayPause}
              className="text-zinc-400 hover:text-zinc-300 border border-zinc-500 rounded-full p-1"
              aria-label={isPlaying ? 'Pause' : 'Play'}
            >
              {isPlaying ? <PauseIcon className="w-4 h-4" fillColor="#d9dedd" /> : <PlayIcon className="w-4 h-4" fillColor="#d9dedd" />}
            </button>
            <span className="text-sm text-zinc-400">My Uploaded Track.mp3</span>
            <span className="ml-auto text-sm text-zinc-500">{new Date(currentTime * 1000).toISOString().substr(14, 5)}</span>
          </div>
        </div>
      </div>
      <Show when={showButtons}>
        <div className="space-y-4 mt-1">
          <div className="flex gap-1">
            <Button onClick={handleRecordAgain} className="bg-[#1d1d1f] flex-1 py-3 rounded-bl-lg text-sm text-white hover:bg-zinc-700">
              Start again
            </Button>
            <Button
              onClick={() => {
                uploadRecordingFile();
                setGeneratorType(GeneratorTypeEnums.R3IMAGINE);
                // hide?.();
              }}
              className="bg-[#393a3a] flex-1 py-3 rounded-br-lg text-sm text-white hover:bg-zinc-700"
            >
              Use Upload
            </Button>
          </div>
        </div>
      </Show>
    </div>
  );
}
